import { useContext } from "react";
import { LightDarkContext, LightDarkContextValue } from "../components/app/LightDarkProvider";

export function useTheme(): LightDarkContextValue {
    return useContext(LightDarkContext);
}
